__turbopack_context__.v({
  "mark": "source-link-module__WYyKya__mark",
  "pending": "source-link-module__WYyKya__pending",
  "sourceLink": "source-link-module__WYyKya__sourceLink",
  "stars": "source-link-module__WYyKya__stars",
});
